import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@hub/breadcrumb';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderBreadcrumb = _ref => {
  let {
    items
  } = _ref;
  if (!Array.isArray(items)) {
    return null;
  }
  return /*#__PURE__*/_jsx(CoreContainer, {
    sx: {
      marginTop: ['spacing-md', null, 'spacing-lg']
    },
    "data-id": "header-breadcrumb_index_HeaderBreadcrumb_CoreContainer",
    children: /*#__PURE__*/_jsx(Stack, {
      minHeight: 48,
      justify: "center",
      "data-id": "header-breadcrumb_index_HeaderBreadcrumb_CoreContainer_Stack",
      children: /*#__PURE__*/_jsx(Breadcrumb, {
        "data-id": "header-breadcrumb_index_HeaderBreadcrumb_Stack_Breadcrumb",
        children: items.map((_ref2, i) => {
          let {
            label,
            url
          } = _ref2;
          const isCurrentPage = i === items.length - 1;
          return /*#__PURE__*/_jsx(BreadcrumbItem, {
            isCurrentPage: isCurrentPage,
            "data-id": "header-breadcrumb_index_HeaderBreadcrumb_BreadcrumbItem",
            children: /*#__PURE__*/_jsx(BreadcrumbLink, {
              href: url,
              "data-id": "header-breadcrumb_index_HeaderBreadcrumb_BreadcrumbItem_BreadcrumbLink",
              children: label
            })
          }, i);
        })
      })
    })
  });
};